import React, { useEffect, useState } from 'react'
import DashboardLayout, { DashboardPage } from '../../layout'
import { useRouter } from '../../../../routes'
import { useData } from '../../../../data'
import { PlusOutlined } from '@ant-design/icons'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import ToolDetails from '../details'
import NewJob from '../../jobs/new_job'

/**
 * This page contains the details of a selected Tool
 * It also provides a list of Jobs under the tools
 */

const ToolDetailsPage = (props) => {
    const [selectedTool, setSelectedTool] = useState(null)
    const [showDrawer, setShowDrawer] = useState(false)

    const router = useRouter()
    const data = useData()
    const tools = data.tools()

    const { query } = router
    const toolId = query && query.id

    /**
     * Redirect back if there is no tool id in query params
     */
    if (!toolId) {
        router.back()
    }

    /**
     * Get the details of a tool
     */
    const getToolDetails = (id) => {
        trackPromise(
            tools.getToolDetails(id)
                .then(tool => {
                    setSelectedTool(tool)
                })
                .catch(({ message }) => console.log(message))
            , 'get_tool_details')
    }

    /**
     * Open a form to create a new job
     */
    const newJob = (tool = null) => {
        setShowDrawer(true)
    }

    /**
     * Close the Drawer
     * Also reload tool and jobs
     */
    const closeDrawer = (job) => {
        setShowDrawer(false)
        const { id } = job
        if (id) {
            router.push(`/dashboard/job?id=${id}`)
        }
        // getToolDetails(toolId)
    }


    // get details
    useEffect(() => {
        getToolDetails(toolId)
    }, [])


    const running = usePromiseTracker({ area: 'get_tool_details' }).promiseInProgress

    return (
        <DashboardLayout selected="tools">
            <DashboardPage
                title="Details"
                ctaIcon={<PlusOutlined />}
                buttonText="Create a Job"
                onCtaClick={() => newJob()}
                loading={running}
            >
                <>
                    <ToolDetails tool={selectedTool} loading={running} />
                </>
                <NewJob
                    visible={showDrawer}
                    close={closeDrawer}
                    tool_id={parseInt(toolId)}
                />
            </DashboardPage>
        </DashboardLayout>
    )
}

export default ToolDetailsPage
